import { clampTo, hasImageInput, resolveImageSize } from '../../tools';
import type { alibabaModelConfig } from '../types';

export const qwenConfigs: Record<string, alibabaModelConfig> = {
    'qwen-image-2.0-pro': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2975126
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2976416
        apiPath: '/api/v1/services/aigc/multimodal-generation/generation',
        pollApiPath: '',
        statusMapping: {
            taskIdPath: '',
            createErrorPath: 'message',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: '',
        },
        synchronous: true,
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            const images = image_urls.slice(0, 3);
            if (hasImage) {
                return {
                    model: 'qwen-image-2.0-pro',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    ...images.map(url => ({
                                        image: url,
                                    })),
                                    {
                                        text: prompt.slice(0, 1300),
                                    },
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: aspectRatio === 'match' ? undefined : resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            } else {
                return {
                    model: 'qwen-image-2.0-pro',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 1300),
                                    }
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            }
        },
    },
    'qwen-image-2.0': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2975126
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2976416
        apiPath: '/api/v1/services/aigc/multimodal-generation/generation',
        pollApiPath: '',
        statusMapping: {
            taskIdPath: '',
            createErrorPath: 'message',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: '',
        },
        synchronous: true,
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            const images = image_urls.slice(0, 3);
            if (hasImage) {
                return {
                    model: 'qwen-image-2.0',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    ...images.map(url => ({
                                        image: url,
                                    })),
                                    {
                                        text: prompt.slice(0, 1300),
                                    },
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: aspectRatio === 'match' ? undefined : resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            } else {
                return {
                    model: 'qwen-image-2.0',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 1300),
                                    }
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            }
        },
    },
    'qwen-image-max': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2975126
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2976416
        apiPath: '/api/v1/services/aigc/multimodal-generation/generation',
        pollApiPath: '',
        statusMapping: {
            taskIdPath: '',
            createErrorPath: 'message',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: '',
        },
        synchronous: true,
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            const images = image_urls.slice(0, 3);
            if (hasImage) {
                return {
                    model: 'qwen-image-edit-max',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    ...images.map(url => ({
                                        image: url,
                                    })),
                                    {
                                        text: prompt.slice(0, 800),
                                    },
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: aspectRatio === 'match' ? undefined : resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'qwen-image-max'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            } else {
                return {
                    model: 'qwen-image-max',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 800),
                                    }
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'qwen-image-max'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            }
        },
    },
    'qwen-image-plus': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2975126
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2976416
        apiPath: '/api/v1/services/aigc/multimodal-generation/generation',
        pollApiPath: '',
        statusMapping: {
            taskIdPath: '',
            createErrorPath: 'message',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: '',
        },
        synchronous: true,
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            const images = image_urls.slice(0, 3);
            if (hasImage) {
                return {
                    model: 'qwen-image-edit-plus',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    ...images.map(url => ({
                                        image: url,
                                    })),
                                    {
                                        text: prompt.slice(0, 800),
                                    },
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: aspectRatio === 'match' ? undefined : resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'qwen-image-plus'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            } else {
                return {
                    model: 'qwen-image-plus',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 800),
                                    }
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'qwen-image-plus'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        prompt_extend: typeof providerOptions?.prompt_extend === 'boolean' ? providerOptions.prompt_extend : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            }
        },
    },
    'qwen-image': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2975126
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=2976416
        apiPath: '/api/v1/services/aigc/multimodal-generation/generation',
        pollApiPath: '',
        statusMapping: {
            taskIdPath: '',
            createErrorPath: 'message',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: '',
        },
        synchronous: true,
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'qwen-image-edit',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        image: image_urls[0],
                                    },
                                    {
                                        text: prompt.slice(0, 800),
                                    },
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            } else {
                return {
                    model: 'qwen-image',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 800),
                                    }
                                ]
                            }
                        ]
                    },
                    parameters: {
                        negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                        size: resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        n: 1,
                    },
                };
            }
        },
    },
};